<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import gender from "../../helpers/list/gender.json";

export default {
  components: { DatePicker },
  props: {},

  data() {
    return {
      full_name: "",
      family_name: "",
      mother_name: "",
      first_name_en: "",
      family_name_en: "",
      gender_id: "",
      birth_date: "",
      number: "",
      issue_date: "",
      expire_date: "",

      //lists
      list_gender: gender,
    };
  },
  validations: {
    full_name: { required, minLength: minLength(8), maxLength: maxLength(50) },
    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    mother_name: { required, minLength: minLength(8), maxLength: maxLength(50) },
    first_name_en: { required, minLength: minLength(2), maxLength: maxLength(50) },
    family_name_en: { required, minLength: minLength(2), maxLength: maxLength(15) },
    gender_id: { required },
    birth_date: { required },
    number: { required, minLength: minLength(2), maxLength: maxLength(10) },
    issue_date: { required },
    expire_date: {
      required,
      minValue(val) {
        if (val != null) {
          val = val.split("-");
          return new Date(val[2], val[1], val[0]) >= new Date(2027, 12, 1);
        }
        return true;
      },
    },
    form: [
      "full_name",
      "family_name",
      "mother_name",
      "first_name_en",
      "family_name_en",
      "gender_id",
      "birth_date",
      "number",
      "issue_date",
      "expire_date",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    EnLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z-]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات جواز سفر الحاج</h5></div>

      <b-form-group
        class="col-md-4 mb-3"
        label="الاسم الثلاثي مطابق للجواز : "
        label-for="full_name"
      >
        <b-form-input
          id="full_name"
          type="text"
          placeholder="ادخل الاسم الثلاثي مطابق للجواز"
          v-model="full_name"
          :class="{ 'is-invalid': $v.full_name.$error }"
        ></b-form-input>
        <div v-if="$v.full_name.$error" class="invalid-feedback">
          <span v-if="!$v.full_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.full_name.minLength"
            >يجب أن يتكون الاسم الثلاثي من 8 حرف على الأقل</span
          >
          <span v-if="!$v.full_name.maxLength"
            >يجب أن يتكون الاسم الثلاثي من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="اللقب مطابق للجواز : "
        label-for="family_name"
      >
        <b-form-input
          id="family_name"
          type="text"
          placeholder="ادخل اللقب مطابق للجواز"
          v-model="family_name"
          :class="{ 'is-invalid': $v.family_name.$error }"
        ></b-form-input>
        <div v-if="$v.family_name.$error" class="invalid-feedback">
          <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.family_name.minLength"
            >يجب أن يتكون اللقب من حرفين على الأقل</span
          >
          <span v-if="!$v.family_name.maxLength"
            >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="اسم الام مطابق للجواز : "
        label-for="mother_name"
      >
        <b-form-input
          id="mother_name"
          type="text"
          placeholder="ادخل اسم الام مطابق للجواز"
          v-model="mother_name"
          :class="{ 'is-invalid': $v.mother_name.$error }"
        ></b-form-input>
        <div v-if="$v.mother_name.$error" class="invalid-feedback">
          <span v-if="!$v.mother_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.mother_name.minLength"
            >يجب أن يتكون اسم الام من 8 حرف على الأقل</span
          >
          <span v-if="!$v.mother_name.maxLength"
            >يجب أن يتكون اسم الام من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-4 mb-3"
        label="الاسم الاول فقط وليس الثلاثي مطابق للجواز (بالانجليزي) : "
        label-for="first_name_en"
      >
        <b-form-input
          id="first_name_en"
          type="text"
          class="en-input"
          placeholder="ادخل الاسم الاول مطابق للجواز (بالانجليزي)"
          v-model="first_name_en"
          v-on:keypress="EnLetter($event)"
          :class="{ 'is-invalid': $v.first_name_en.$error }"
        ></b-form-input>
        <div v-if="$v.first_name_en.$error" class="invalid-feedback">
          <span v-if="!$v.first_name_en.required">هذا الحقل الزامي</span>
          <span v-if="!$v.first_name_en.minLength"
            >يجب أن يتكون الاسم الاول من 2 حرف على الأقل</span
          >
          <span v-if="!$v.first_name_en.maxLength"
            >يجب أن يتكون الاسم الاول من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="اللقب مطابق للجواز (بالانجليزي) : "
        label-for="family_name_en"
      >
        <b-form-input
          id="family_name_en"
          type="text"
          class="en-input"
          placeholder="ادخل اللقب مطابق للجواز (بالانجليزي)"
          v-model="family_name_en"
          v-on:keypress="EnLetter($event)"
          :class="{ 'is-invalid': $v.family_name_en.$error }"
        ></b-form-input>
        <div v-if="$v.family_name_en.$error" class="invalid-feedback">
          <span v-if="!$v.family_name_en.required">هذا الحقل الزامي</span>
          <span v-if="!$v.family_name_en.minLength"
            >يجب أن يتكون اللقب من حرفين على الأقل</span
          >
          <span v-if="!$v.family_name_en.maxLength"
            >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" الجنس : " label-for="gender_id">
        <select
          class="form-control"
          id="gender_id"
          v-model="gender_id"
          :class="{ 'is-invalid': $v.gender_id.$error }"
        >
          <option value="">اختر الجنس</option>
          <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
            {{ gender.name }}
          </option>
        </select>
        <div v-if="$v.gender_id.$error" class="invalid-feedback">
          <span v-if="!$v.gender_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label="تاريخ التولد : " label-for="birth_date">
        <date-picker
          id="birth_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder='ادخل الصيغة التالية   "يوم ثم شهر ثم سنة"'
          v-model="birth_date"
          :class="{ 'is-invalid': $v.birth_date.$error }"
        ></date-picker>
        <div v-if="$v.birth_date.$error" class="invalid-feedback">
          <span v-if="!$v.birth_date.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" رقم جواز السفر : " label-for="number">
        <b-form-input
          id="number"
          type="text"
          placeholder="ادخل رقم جواز السفر "
          v-model="number"
          :class="{ 'is-invalid': $v.number.$error }"
        ></b-form-input>
        <div v-if="$v.number.$error" class="invalid-feedback">
          <span v-if="!$v.number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.number.minLength"
            >يجب أن يتكون رقم جواز السفر من 2 رقم او حرف واحد على الأقل</span
          >
          <span v-if="!$v.number.maxLength"
            >يجب أن يتكون رقم جواز السفر من 10 رقم او حرف على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label="تاريخ اصدار جواز السفر : "
        label-for="issue_date"
      >
        <date-picker
          id="issue_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder='ادخل الصيغة التالية   "يوم ثم شهر ثم سنة"'
          v-model="issue_date"
          :class="{ 'is-invalid': $v.issue_date.$error }"
        ></date-picker>
        <div v-if="$v.issue_date.$error" class="invalid-feedback">
          <span v-if="!$v.issue_date.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="تاريخ نفاذ جواز السفر : "
        label-for="expire_date"
      >
        <date-picker
          id="expire_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder='ادخل الصيغة التالية   "يوم ثم شهر ثم سنة"'
          v-model="expire_date"
          :class="{ 'is-invalid': $v.expire_date.$error }"
        ></date-picker>
        <div v-if="$v.expire_date.$error" class="invalid-feedback">
          <span v-if="!$v.expire_date.required">هذا الحقل الزامي</span>
          <span v-if="!$v.expire_date.minValue"
            >تاريخ نفاذ الجواز يجب ان يكون اكبر اويساوي 1-12-2027</span
          >
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
